import { useColorContext } from '../contexts/ColorContext';
import { SemanticColorSearchPanel } from '../components/SemanticColorSearchPanel';
import { useToolInit } from '../hooks/useToolInit';

export function SemanticTool() {
  const { displayResult, copiedField, copyToClipboard } = useColorContext();
  const { params } = useToolInit();

  return (
    <SemanticColorSearchPanel
      backgroundHex={displayResult?.hex ?? null}
      copiedField={copiedField}
      onCopy={copyToClipboard}
      initialQuery={params.q}
    />
  );
}
